module.exports = "//cdn.mxpnl.com/static/asset-cache/88027a4bee2bf4b0be3f564746dfbd7d/iron/common/assets/images/charts/cumulative-stacked-line.svg";